var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftwareDeveloper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0102 30L15.204 24.0087C14.932 23.7274 14.932 23.2719 15.204 22.9913L21.0102 17L21.9963 18.0175L16.6831 23.5L21.9963 28.9825L21.0102 30ZM34.9895 30L34.0034 28.9825L39.3166 23.5L34.0034 18.0175L34.9895 17L40.7957 22.9913C40.9268 23.1265 41 23.3093 41 23.5C41 23.6907 40.9268 23.8742 40.7957 24.0087L34.9895 30Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4784 17.4625L25.2257 29.4233L26.5228 29.8845L30.7756 17.9237L29.4784 17.4625Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.903 8H6.097C3.83787 8 2 9.81425 2 12.0443V41.9557C2 44.1858 3.83787 46 6.097 46H49.903C52.1621 46 54 44.1858 54 41.9557V12.0443C54 9.81425 52.1621 8 49.903 8ZM52.6233 41.9557C52.6233 43.4363 51.4029 44.641 49.903 44.641H6.097C4.59711 44.641 3.37668 43.4363 3.37668 41.9557V12.0443C3.37668 10.5637 4.59711 9.35899 6.097 9.35899H49.903C51.4029 9.35899 52.6233 10.5637 52.6233 12.0443V41.9557Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 53H33V46H23V53Z",
    fill: "#7617DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2915 45H22.7085C22.3174 45 22 45.3062 22 45.685V53.315C22 53.6931 22.3174 54 22.7085 54H33.2915C33.6826 54 34 53.6931 34 53.315V45.685C34 45.3062 33.6826 45 33.2915 45ZM32.583 52.63H23.417V46.37H32.583V52.63Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38H3V39H53V38Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53H18V54H38V53Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDeveloper);
export default __webpack_public_path__ + "static/media/software-developer.7459ed304c4000b11bdb6764eae32c2f.svg";
export { ForwardRef as ReactComponent };